import { CreateFileInput } from "../../../Shared/dto/create-file-input";
import { PageOptionsDto } from "../../../Shared/dto/page.options.dto";
import { HttpService } from "../../../Shared/Utils/HttpService";
import { CreateDriverInput } from "../models/CreateDriverInput";

export class DriverService {
  static async create(createDriverInput: CreateDriverInput) {
    return await HttpService.request({
      url: "/drivers/create",
      method: "POST",
      data: createDriverInput,
    });
  }

  static async createFromFile(createFromFileInput: CreateFileInput) {
    return await HttpService.request({
      url: "/drivers/create/from-file",
      method: "POST",
      data: createFromFileInput,
    });
  }

  static async getById(id: string) {
    return await HttpService.request({
      url: `/drivers/find/${id}`,
      method: "GET",
    });
  }

  static async update(id: string, updateDriverInput: CreateDriverInput) {
    return await HttpService.request({
      url: `/drivers/${id}`,
      method: "PUT",
      data: updateDriverInput,
    });
  }

  static async deleteOne(id: string) {
    return await HttpService.request({
      url: `/drivers/${id}`,
      method: "DELETE",
    });
  }

  static async delete(ids: string[]) {
    return await HttpService.request({
      url: `/drivers/${JSON.stringify(ids)}`,
      method: "DELETE",
    });
  }

  static async getAll(pageOptions: PageOptionsDto) {
    const queryParams = new URLSearchParams({
      order: pageOptions.order || "DESC",
      page: pageOptions.page.toString(),
      query: pageOptions.query || "",
      take: pageOptions.take.toString(),
    }).toString();

    return await HttpService.request({
      url: `/drivers/find?${queryParams}`,
      method: "GET",
    });
  }

  static async findAll(findOptions: Object) {
    const query = encodeURIComponent(JSON.stringify(findOptions));
    return await HttpService.request({
      url: `/drivers?findOptions=${query}`,
      method: "GET",
    });
  }

  static async search(query: string) {
    return await HttpService.request({
      url: `/drivers/search?query=${encodeURIComponent(query)}`,
      method: "GET",
    });
  }
}
